import React from "react";

import { Route, Routes, Navigate } from "react-router-dom";

import { useLocation } from "react-router";

// @ts-ignore
import useGoogleAnalytics from "../../hooks/useGoogleAnalytics";

import { ActivationsProvider } from "./Context";

import Container from "./Container";
import RetrieveDetails from "./RetrieveDetails";
import Enrol from "./Enrol";
import EyeCheckMessage from "./EyeCheckMessage";
import FindOwnProvider from "./FindOwnProvider";

type PropsType = {
  csrfToken: string;
};

export default function Activations({ csrfToken }: PropsType) {
  useGoogleAnalytics();

  const location = useLocation();

  return (
    <ActivationsProvider>
      <Container>
        <Routes>
          <Route
            path={`/`}
            element={<Navigate to={`retrieve_details${location.search}`} />}
          />
          <Route path={`retrieve_details`} element={<RetrieveDetails />} />
          <Route path={`enrol`} element={<Enrol csrfToken={csrfToken} />} />
          <Route path={`eye_check_message`} element={<EyeCheckMessage />} />
          <Route path={`find_own_provider`} element={<FindOwnProvider />} />
        </Routes>
      </Container>
    </ActivationsProvider>
  );
}
